<template>
  <div>
    <div class="nav-container">
      <nav class="d-flex align-center">
        <div @click="toggle = !toggle" id="menu-toggle-icon"></div>
        <!-- Apply proper styling to show/hide sidebar base on toggle value -->
        <div>
          <a class="navbar-brand" href="/">{{ title }}</a>
        </div>
      </nav>
    </div>
    <sidebar :style="toggle ? openMenuStyle : closeMenuStyle"/>
    <div
      class="dismiss-overlay"
      v-if="toggle"
      @click="toggle = !toggle"
    ></div>
    <!-- TODO add fade animation.
    current conflict - must set display state after css3 animation
    :class="{ fadeIn : toggle, fadeOut: !toggle }" -->
  </div>
</template>


<script>
import Sidebar from '@/containers/dashboard/Sidebar'
// Temporarily disabled css file import because it loads the css file to all components.
// import '@/assets/styles/mobile-nav.css'

export default {
  data() {
    return {
      showOverlay: false,
      toggle: false,
      openMenuStyle: {
        left: '0px !important'
      },
      closeMenuStyle: {
        left: '-300px !important'
      }
    }
  },
  components: {
    sidebar: Sidebar
  },
  name: 'dashboard-mobile-nav',
  props: {
    title: {
      type: String,
      default: 'YeyPass'
    }
  }
}
</script>

<style scoped>
/* Set border bottom only on SCOPE because bootstrap css overrides external stylesheet
and removes the bottom border on small screen size. */
.nav-container {
  border-bottom: 1px solid #e5e9eb !important;
}

/* Temporarily placed mobile-nav.css content */

/* Override nav classes */
.nav-container {
  margin-top: 0px !important;
  position: fixed;
  width: 100%;
  z-index: 997;
  background: #fff;
  padding: 12px !important;
}

.navbar-brand {
  color: #0091f4;
  font-size: 18px;
  padding-left: 64px;
  font-family: 'HKGrotesk-Semibold', Helvetica, sans-serif;
}

/* Menu icon */
#menu-toggle {
  position: absolute;
  opacity: 0;
}

/* Set to fix dimension and fix position to provide larger area than the icon */
#menu-toggle-icon {
  display: block;
  width: 50px;
  height: 50px;
  position: fixed;
  background: url('~@/assets/img/icon-menu.png') no-repeat;
  background-size: 48%;
  margin: 0;
  background-position: center;
}

/* Where the magic happens.
This classes are dynamically binded to the sidebar to set its position for display visibility */
.close-menu {
  left: -300px !important;
  /* -webkit-overflow-scrolling: touch; */
}

.open-menu {
  left: 0 !important;
}

/* Animation */

/* adds animation for all transitions
This enables the sidebar slide in/out animation to happen
 */
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -o-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: none;
}

.dismiss-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(12, 57, 103, 0.33);
  z-index: 998;
}

.fadeIn {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -webkit-transition: opacity 0.5s ease-in-out;
}

.fadeOut {
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
  -moz-transition: opacity 0.25s ease-in-out;
  -webkit-transition: opacity 0.25s ease-in-out;
}


</style>



// WEBPACK FOOTER //
// src/components/common/DashboardMobileNav.vue